import { render, staticRenderFns } from "./NewsListPage.vue?vue&type=template&id=30ec3fcf&scoped=true"
import script from "./NewsListPage.vue?vue&type=script&lang=js"
export * from "./NewsListPage.vue?vue&type=script&lang=js"
import style0 from "./NewsListPage.vue?vue&type=style&index=0&id=30ec3fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ec3fcf",
  null
  
)

export default component.exports